export const FETCH_MEDIA_INFORMATION_REQUEST =
  "FETCH_MEDIA_INFORMATION_REQUEST";
export const FETCH_MEDIA_INFORMATION_SUCCESS =
  "FETCH_MEDIA_INFORMATION_SUCCESS";
export const FETCH_MEDIA_INFORMATION_FAIL = "FETCH_MEDIA_INFORMATION_FAIL";

export const CREATE_MEDIA_INFORMATION_REQUEST =
  "CREATE_MEDIA_INFORMATION_REQUEST";
export const CREATE_MEDIA_INFORMATION_SUCCESS =
  "CREATE_MEDIA_INFORMATION_SUCCESS";
export const CREATE_MEDIA_INFORMATION_FAIL = "CREATE_MEDIA_INFORMATION_FAIL";

export const UPDATE_MEDIA_INFORMATION_REQUEST =
  "UPDATE_MEDIA_INFORMATION_REQUEST";
export const UPDATE_MEDIA_INFORMATION_SUCCESS =
  "UPDATE_MEDIA_INFORMATION_SUCCESS";
export const UPDATE_MEDIA_INFORMATION_FAIL = "UPDATE_MEDIA_INFORMATION_FAIL";

export const CREATE_MEDIA_ALL_INFO_PATIENT_REQUEST =
  "CREATE_MEDIA_ALL_INFO_PATIENT_REQUEST";
export const CREATE_MEDIA_ALL_INFO_PATIENT_SUCCESS =
  "CREATE_MEDIA_ALL_INFO_PATIENT_SUCCESS";
export const CREATE_MEDIA_ALL_INFO_PATIENT_FAIL =
  "CREATE_MEDIA_ALL_INFO_PATIENT_FAIL";
